import React from 'react';
import { Routes } from 'react-router-dom';
import ProtectedRoute from '../../components/helpers/ProtectedRoute';
import List from './List';
import ManageContact from './ManageContact';

export default () => (
	<Routes>
		<ProtectedRoute exact path="/manage/directory" component={List} />
		<ProtectedRoute
			exact
			path="/manage/directory/new"
			component={ManageContact}
		/>
		<ProtectedRoute exact path="/manage/directory/:id" component={List} />
		<ProtectedRoute
			exact
			path="/manage/directory/:id/edit"
			component={ManageContact}
		/>
		<ProtectedRoute
			exact
			path="/manage/directory/:id/assets"
			component={List}
		/>
	</Routes>
);
